export const state = () => ({
  list: [],
})

export const mutations = {
  add(state, text) {
    state.list.push({
      text,
      done: false,
    })
  },
  remove(state, { todo }) {
    state.list.splice(state.list.indexOf(todo), 1)
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  toggle(state, todo) {
    todo.done = !todo.done
  },
}
